module.exports = __webpack_public_path__ + "img/e-xiongwei-nv.4c61d8c0.jpg";